/**
 * Trigger: tr_currencies_update_default
 * Purpose: Ensure only one currency is marked as default
 * Table: currencies
 * Event: UPDATE OF is_default
 */
export const TR_CURRENCIES_UPDATE_DEFAULT = `
CREATE TRIGGER tr_currencies_update_default
UPDATE OF is_default ON currencies
BEGIN
  UPDATE currencies
  SET is_default = 0
  WHERE is_default = 1
    AND new.is_default <> old.is_default
    AND new.is_default = 1
    AND _id <> new._id;
END;
`;
